import { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';
import { Switch, Route, useLocation, useRouteMatch } from 'react-router-dom';

import TicketsMenu from './tickets-menu';
import TicketsIndex from './tickets-index';
import TicketsDetail from './tickets-detail';
import TicketMasterIndex from './tickets-master-index';
import TicketMasterDetail from './tickets-master-detail';

import ViewTitle from '../../common/view-title';
import Loader from '../../common/loader';
import NotFound from '../../common/not-found';

import helpers from '../../utils/helpers';
import TicketBalance from './tickets-balance';

const useStyles = makeStyles(() => ({
    root: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column'
    }
}));

const Tickets = () => {

    const classes = useStyles();
    const { pathname } = useLocation();
    const { path } = useRouteMatch();
    const [state, setState] = useState({
        loading: true,
        permissions: {}
    });

    useEffect(() => {
        const validatePermissions = () => {
            const permissions = helpers.getPermissions(pathname);
            setState(prev => ({ ...prev, permissions, loading: false }));
        }

        validatePermissions();
    }, []);

    if (state.loading) return <Loader />;

    if (!state.permissions?.read_attr) return <NotFound />;

    return (
        <div className={classes.root}>
            <ViewTitle sedeFlag title='Tickets' />

            <Switch>
                <Route exact path={path}><TicketsMenu permissions={state.permissions} /></Route>
                <Route exact strict path={`${path}/master/index`}><TicketMasterIndex permissions={state.permissions} /></Route>
                <Route exact strict path={`${path}/master/:id`}><TicketMasterDetail permissions={state.permissions} /></Route>
                <Route exact strict path={`${path}/balance`}><TicketBalance permissions={state.permissions} /></Route>
                <Route exact strict path={`${path}/index`}><TicketsIndex permissions={state.permissions} /></Route>
                <Route exact strict path={`${path}/:id`}><TicketsDetail permissions={state.permissions} /></Route>
                <Route path={`${path}/*`}><NotFound /></Route>
            </Switch>
        </div>
    );
}

export default Tickets;